import { isFeatureEnabled } from './alerts_access'

// The Coaching Portal stands on its own: every access gate -- the nav rail
// (nav/registry.js), the router guard, the dashboard widget, and the API's
// _require_coaching_feature -- reads coaching_portal_enabled plus a role, and
// nothing else. It does NOT require ERM or Driver Manager. Tickets can be
// raised manually (coaching_add_ticket_modal writes source: 'manual'), and
// where ERM happens to be on, a driver-tagged event can push one too.
//
// Two of its five pages are the exception. Flagged Drivers and Recognition
// Candidates are built entirely from driver scorecard rows, and those rows are
// only ever written for a tenant whose scorecard flag is on -- see the pre-calc
// jobs' own tenant filters (fleet-int-api/reports/cm_precalc_driver_scorecards.py
// and tbn-integration/reports/tbn_precalc_driver_scorecards.py). The scorecard
// read endpoints are not flag-gated, so without the flag those pages load
// cleanly and show nothing, forever -- a dead page rather than an honest
// absence. Hide them instead; coaching runs on manually raised tickets.
//
// driver_scorecard_enabled for BOTH tenant types, matching the Driver Manager
// section gate in nav/registry.js (ben's call, 2026-08-16: scorecards work for
// TBN and CM alike). cm_driver_scorecard_enabled exists as well, but only the
// CM pre-calc job reads it -- no frontend surface ever has.
export function hasScorecardCoachingPages(features) {
  return isFeatureEnabled((features || {}).driver_scorecard_enabled)
}

// the coaching routes fed by scorecard rows, so the router guard and any
// future surface gate the same two pages rather than listing them by hand
export const SCORECARD_COACHING_ROUTES = ['coaching_flagged', 'coaching_recognition']
